module.exports = __webpack_public_path__ + "assets/facebook.17b57389.svg";